import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Sidebar} from "primereact/sidebar";
import {addLocale} from "primereact/api";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {ProgressBar} from 'primereact/progressbar';
import moment from "moment";
import axios from "axios";
import Cookies from "js-cookie";

import _FM_PriceUnitFormComponent from "../components/_FM_pice/_FM_PriceUnitFormComponent";
import _FM_PriceCategoryFormComponent from "../components/_FM_pice/_FM_PriceCategoryFormComponent";
import currencyFormatter from "currency-formatter";
import allLocales from "@fullcalendar/core/locales-all";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react";
import HelpComponent from "../components/HelpComponent";

const _FM_PricePage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {date, resource, action, id} = useParams();
  const [accommodations, setAccommodations] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [resources, setResources] = useState([])
  const [events, setEvents] = useState([])
  const [selectedDate, setSelectedDate] = useState(moment().subtract(0, 'days').toDate());
  const [loading, setLoading] = useState(false)
  const [isEventClicked, setIsEventClicked] = useState(false)
  const [screenSize, setScreenSize] = useState(getScreenSize());
  const calendarRef = useRef(null);

  function getScreenSize() {
    const width = window.innerWidth;
    if (width < 768) return "small";
    if (width >= 768 && width < 1024) return "medium";
    if (width >= 1024 && width < 1440) return "large";
    return "xlarge";
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  const buildCalendar = async (dateFrom, dateTo) => {
    setLoading(true)
    try {
      if (localStorage.getItem('selectedAccommodation')) {

        // get categories by accommodation
        const categories_ = await apiCall('get', 'residential-category?search[accommodation]=' + localStorage.getItem('selectedAccommodation') || accommodations[0].id)
        let _categories = []
        categories_.data.data.items.map((cat, index) => {
          _categories.push({
            id: cat.id,
            label: cat.name,
            type: 'category',
            eventCreation: false,
            originalId: cat.id,
            level: 1,
          })
        })
        if (!categories_.data.data.items[0]) {
          window.App.toastShow('warn', t('warning'), t('no_category_found'));
          setResources([])
          setEvents([])
          setLoading(false)
          return false
        }

        // get units
        const units_ = await apiCall('get', 'residential-unit/tree?search[accommodation]=' + localStorage.getItem('selectedAccommodation'))
        let _units = []
        units_.data.map((unit, index) => {
          let _children = []
          if (unit.children && unit.children[0]) {
            unit.children.map((child, index) => {
              _children.push({
                id: child.residential_category.id + "-" + unit.id + "-" + child.id + "U",
                label: child.name,
                type: 'unit',
                eventCreation: false,
                parentId: unit.residential_category.id + "-" + unit.id,
                originalId: child.id,
                level: 3,
                children: child.berths,
                berths: child.berths.length,
                is_ready: child.is_ready,
                clean: child.clean,
              })
            })
          }
          _units.push({
            id: unit.residential_category.id + "-" + unit.id,
            label: unit.name,
            type: 'unit',
            eventCreation: false,
            parentId: unit.residential_category.id,
            originalId: unit.id,
            level: 2,
            children: _children,
            berths: unit.berths.length,
            is_ready: unit.is_ready,
            clean: unit.clean,
          })
        })
        if (!units_.data[0]) {
          window.App.toastShow('warn', t('warning'), t('no_unit_found'));
          setLoading(false)
          return false
        }

        // get beds
        const beds_ = await apiCall('get', 'berth?search[accommodation]=' + localStorage.getItem('selectedAccommodation'))
        let _beds = []
        beds_.data.data.items.map((bed, index) => {
          _beds.push({
            id: bed.residential_unit.residential_category.id + "-" + bed.residential_unit.id + "-" + bed.id,
            label: bed.name,
            type: 'bed',
            eventCreation: false,
            parentId: bed.residential_unit.residential_category.id + "-" + bed.residential_unit.id,
            originalId: bed.id,
            level: 3,
          })
        })

        let categories = _categories
        let units = _units
        let beds = _beds

        // build calendar data
        if (units[0] && categories[0]) {
          let _nodes = []
          categories.map((category, index) => {
              let _units = units.filter(item => item.parentId === category.originalId)
              let __units = []
              _units.map((unit, index) => {
                let _beds = beds.filter(item => item.parentId === unit.id)
                if (unit.children && unit.children[0]) {
                  unit.children.map((child, index) => {
                    let ___beds = []
                    if (child.children && child.children[0]) {
                      child.children.map((bed, index) => {
                        // ___beds.push({
                        //   id: category.originalId + "-" + unit.originalId + "-" + bed.id,
                        //   label: bed.name,
                        //   type: 'bed',
                        //   eventCreation: false,
                        //   originalId: bed.id,
                        //   level: 4,
                        // })
                      })
                    }
                    child.children = ___beds
                    _beds.push(child)
                  })
                }
                __units.push({
                  ...unit,
                  //children: _beds,
                })
              })
              _nodes.push({
                ...category,
                children: __units
              })
            }
          )
          setResources(_nodes)
          if (_nodes[0]) {
            //build events
            let _events = []
            const _prices = await apiCall('get',
              //'rack-price?search[reserved_from][operator]=between&search[reserved_from][value]=' + dateFrom + ',' + dateTo)
              'price?&item_per_page=9999&search[price_category][operator]=%3D&search[price_category][value]=' + selectedCategory)
            for (const price of _prices.data.data.items) {
              if (!price.deleted_at_snapshot) {
                let resource
                let type = 'unit'
                if (price.residential_unit && price.residential_unit.id) {
                  let _resource = units.filter(item => item.originalId === price.residential_unit.id)[0]
                  resource = _resource?.parentId + '-' + price.residential_unit.id
                  if (price?.residential_unit?.parent?.id) {
                    _resource = units.filter(item => item.originalId === price.residential_unit.parent.id)[0]
                    resource = price.residential_unit.residential_category.id + "-" + price.residential_unit.parent.id + '-' + price.residential_unit.id + "U"
                  }
                  type = 'unit'
                }
                if (price.berth && price.berth.id) {
                  resource = price.berth.id
                  type = 'berth'
                }
                if (type === 'unit') {
                  _events.push({
                    id: price.id,
                    originalId: price.id,
                    start: price.date,
                    end: price.date,
                    title: price.id,
                    status: '',
                    type: type,
                    note: price.note,
                    priceId: "" + price.id,
                    resource: resource,
                    resourceId: resource,
                    allDay: true,
                    adultPrice: price.adult_price,
                    childPrice: price.child_price,
                    unitPrice: price.unit_price || price.berth_price,
                    include_tourist_tax: price.include_tourist_tax,
                    display: 'background',
                  })
                }
              }
            }
            setEvents(_events)
            setLoading(false)
          }
        }
      } else {
        setLoading(false)
        window.App.toastShow('warn', t('warning'), t('no_accommodation_found'));
      }
    } catch
      (error) {
      setLoading(false)
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    }
  };

  useEffect(() => {
    document.title = t('prices') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/price')
    // if (window.App.state.rerenderReservationList === true || window.App.state.rerenderOoounitList === true || window.App.state.rerenderOooberthList === true) {
    //   const dateFrom = moment(selectedDate).format("YYYY-MM-DD");
    //   const dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
    //   buildPrice(dateFrom, dateTo);
    // }
    if (localStorage.getItem('selectedAccommodation') !== 'undefined') {
      apiCall('get', 'accommodation')
        .then(response => {
          if (response.data.data.items[0]) {
            setAccommodations(response.data.data.items)
            if (!localStorage.getItem('selectedAccommodation')) {
              localStorage.setItem('selectedAccommodation', response.data.data.items[0].id)
            }
            apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]=' + localStorage.getItem('selectedAccommodation'))
              .then(response => {
                setCategories(response.data.data.items)
                setSelectedCategory(response.data.data.items[0].id)
              })
              .catch(error => {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              })
          } else {
            window.App.toastShow('warn', t('warning'), t('no_accommodation_found'));
            return false
          }
        })
        .catch(error => {

        })
    }
  }, [localStorage.getItem('selectedAccommodation')]);

  useEffect(() => {
    const dateFrom = moment(selectedDate).format("YYYY-MM-DD");
    const dateTo = moment(selectedDate).add(22, "days").format("YYYY-MM-DD");
    if (localStorage.getItem('selectedAccommodation') !== 'undefined') {
      buildCalendar(dateFrom, dateTo);
    } else {
      apiCall('get', 'accommodation')
        .then(response => {
          if (response.data.data.items[0]) {
            setAccommodations(response.data.data.items)
            localStorage.setItem('selectedAccommodation', response.data.data.items[0].id)
          }
        })
        .catch(error => {

        })
    }
    if (calendarRef.current) {
      calendarRef.current.getApi().gotoDate(moment(selectedDate).format('YYYY-MM-DD'));
    }
  }, [selectedCategory, selectedDate, localStorage.getItem('selectedAccommodation'), window.App.state.rerenderPriceList]);

  return (
    <>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px'}}></ProgressBar>
      }
      <div className="_FM_CalendarPage _FM_PricePage p-component p-my-lg-4 p-mx-lg-1">
        <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/price"}/>
        <div className={""}>
          <div className={"p-grid calendar-controls"}>
            <div className={"p-col-12 p-lg-6 p-col-align-center"}>
              <Button label={"-14"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(14, 'days').toDate())
                      }}/>
              <Button label={"-7"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(7, 'days').toDate())
                      }}/>
              <Button label={"-2"}
                      disabled={loading}
                      className={"p-mr-2 p-button-warning"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(2, 'days').toDate())
                      }}/>
              <Button label={t('today')}
                      disabled={loading}
                      className={"p-mr-2 p-button-info"}
                      onClick={() => {
                        setSelectedDate(moment().subtract(0, 'days').toDate())
                      }}/>
              <Button label={"+2"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-2, 'days').toDate())
                      }}/>
              <Button label={"+7"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-7, 'days').toDate())
                      }}/>
              <Button label={"+14"}
                      disabled={loading}
                      className={"p-mr-2 p-button-success"}
                      onClick={() => {
                        setSelectedDate(moment(selectedDate).subtract(-14, 'days').toDate())
                      }}/>
              <Calendar value={selectedDate}
                        disabled={loading}
                        style={{maxWidth: '140px'}}
                        dateFormat={t('YY-MM-DD')}
                        locale={"default"}
                        showIcon
                        onChange={(e) => {
                          if (e.value !== null) {
                            setSelectedDate(e.value)
                          }
                        }}/>
            </div>
            <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
              <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
              <Dropdown  options={accommodations}
                        className={"p-ml-2 p-text-left"}
                        optionLabel="name"
                        optionValue="id"
                        id={"accommodation"}
                        emptyMessage={t('empty_message')}
                        onChange={(e) => {
                          window.App.setState({
                            rerenderReservationList: Math.random(),
                          })
                          localStorage.setItem('selectedAccommodation', e.value)
                        }}
                        value={Number(localStorage.getItem('selectedAccommodation'))}
              />
              <Dropdown  options={categories}
                        className={"p-ml-2 p-text-left"}
                        optionLabel="name"
                        optionValue="id"
                        emptyMessage={t('empty_message')}
                        onChange={(e) => {
                          setSelectedCategory(e.value)
                        }}
                        value={selectedCategory}
              />
            </div>
          </div>
          <FullCalendar
            ref={calendarRef}
            initialDate={moment(selectedDate).format("YYYY-MM-DD")}
            locales={allLocales}
            locale={Cookies.get("language")}
            headerToolbar={false}
            plugins={[resourceTimelinePlugin, interactionPlugin]}
            resources={resources}
            events={events}
            schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
            views={{
              resourceTimelineXlarge: {
                type: "resourceTimeline",
                duration: {days: 7},
                slotDuration: {hours: 24},
              },
              resourceTimelineLarge: {
                type: "resourceTimeline",
                duration: {days: 5},
                slotDuration: {hours: 24},
              },
              resourceTimelineMedium: {
                type: "resourceTimeline",
                duration: {days: 3},
                slotDuration: {hours: 24},
              },
              resourceTimelineSmall: {
                type: "resourceTimeline",
                duration: {days: 1},
                slotDuration: {hours: 24},
              },
            }}
            initialView={
              screenSize === "small"
                ? "resourceTimelineSmall"
                : screenSize === "medium"
                  ? "resourceTimelineMedium"
                  : screenSize === "large"
                    ? "resourceTimelineLarge"
                  : "resourceTimelineXlarge"
            }
            eventDidMount={(info) => {
              const eventEl = info.el;
              const eventStart = moment(info.event.start);
              const now = moment();
              if (eventStart.isBefore(now, 'day')) {
                eventEl.classList.add('fc-event-past');
              } else {
                eventEl.classList.add('fc-event-future');
              }
            }}
            eventContent={(event) => {
              return (
                <div id={"price-" + event.event._def.extendedProps.originalId}
                     className={"p-grid event price" + " type-"
                       + event.event._def.extendedProps.type} style={{height: '37px'}}>
                  <div className={"p-grid p-nogutter p-ai-center p-jc-center p-mx-auto"}>
                    <div className={"p-col p-px-1 p-text-right"} >
                      <span className={"p-text-bold"}
                            style={{display: 'block', overflow: 'hidden', textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                        {event.event._def.extendedProps?.type === 'unit' ? (
                          <i className={"pi pi-home p-mr-1"} style={{fontSize: '0.8rem'}}></i>
                        ) : (
                          <i className={"pi pi-inbox p-mr-1"} style={{fontSize: '0.7rem'}}></i>
                        )}
                        {currencyFormatter.format(
                          event.event._def.extendedProps.unitPrice, {
                            precision: t('currency_precision'),
                            symbol: t('currency_symbol'),
                            decimal: t('currency_decimal'),
                            thousand: t('currency_thousand'),
                          }
                        )}
                      </span>
                    </div>
                    <div className={"p-col p-px-1 p-text-right"}>
                      {event.event._def.extendedProps?.type === 'unit' && (
                        <span
                          style={{fontSize: '0.8rem', display: 'block', overflow: 'hidden', textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                          <i className={"pi pi-user p-mr-1"} style={{fontSize: '0.7rem'}}></i>
                          {currencyFormatter.format(
                            event.event._def.extendedProps.adultPrice, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )}
                        </span>
                      )}
                    </div>
                    <div className={"p-col p-px-1 p-text-right"}>
                      {event.event._def.extendedProps?.type === 'unit' && (
                        <span
                          style={{fontSize: '0.8rem', display: 'block', overflow: 'hidden', textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                          <i className={"pi pi-users p-mr-1"} style={{fontSize: '0.8rem'}}></i>
                          {currencyFormatter.format(
                            event.event._def.extendedProps.childPrice, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )}
                        </span>
                      )}
                    </div>
                    <div className={"p-col-1 p-text-left p-pl-1"} style={{fontSize: '0.7rem', lineHeight:'8px'}}>
                        {(() => {
                          let _accommodation = accommodations.filter(item => item.id === Number(localStorage.getItem('selectedAccommodation')))[0]
                          return _accommodation?.currency_code
                        })()}
                        {event.event._def.extendedProps.include_tourist_tax === false &&
                          <span style={{opacity: 0.5, display:'block', lineHeight:'8px'}}>+{t('tourist_tax')}</span>
                        }
                    </div>
                  </div>
                </div>
              )
            }}
            resourceLabelContent={(resource) => {
              return (
                <div style={{paddingLeft: `${resource?.resource?._resource?.extendedProps?.level * 15}px`}}>
                  {resource?.resource?._resource?.extendedProps?.label}
                </div>
              );
            }}
            resourceAreaWidth={'220px'}
            resourceAreaHeaderContent={() => {
              return (
                <>&nbsp;</>
              )
            }}
            height={'auto'}
            width={'auto'}
            expandRows={false}
            slotLabelContent={(day) => {
              if (day.level === 0) {
                return (
                  <div
                    className={"day p-text-center " + moment.utc(day.date).local().format('ddd').toLowerCase() + " is-active-" + day.isActive}
                    data-today={moment.utc(day.date).local().format('YYYY-MM-DD') == moment.utc(new Date(Date.now())).local().format('YYYY-MM-DD')}
                    data-selected={moment.utc(day.date).local().format('YYYY-MM-DD') == moment.utc(selectedDate).local().format('YYYY-MM-DD')}>
                  <span className={"p-d-block"}>
                    {moment.utc(day.date).local().format('DD')}
                  </span>
                    <span className={"p-d-block"}>
                    {t(moment.utc(day.date).local().format('ddd').toLowerCase())}
                  </span>
                    <span className={"p-d-block"}>
                    {moment.utc(day.date).local().format('YY')}
                      &nbsp;
                      {t(moment.utc(day.date).local().format('MMM').toLowerCase())}
                  </span>
                  </div>
                )
              } else {
                return false
              }
            }}
            eventClick={(event) => {
              setIsEventClicked(true);
              setTimeout(() => setIsEventClicked(false), 100);
              navigate('/price/' + moment(event.startDate).format("YYYY-MM-DD") + '/' + event.event._def.extendedProps.type.charAt(0).toUpperCase()
                + '-' + event.event._def.extendedProps.resource + '/update/' + event.event._def.extendedProps.originalId)
            }}
            dateClick={(date) => {
              if (isEventClicked || screenSize === "small" || screenSize === "medium") {
                return;
              }
              if (date && date.resource && date.resource._resource.extendedProps.type !== 'category') {
                navigate('/price/' + moment(date.date).format("YYYY-MM-DD") + '/' + date.resource._resource.extendedProps.type.charAt(0).toUpperCase()
                  + '-' + date.resource._resource.extendedProps.originalId + '?categoryId=' + selectedCategory)
              } else {
                navigate('/price/' + moment(date.date).format("YYYY-MM-DD") + '/' + date.resource._resource.extendedProps.type.charAt(0).toUpperCase()
                  + '-' + date.resource._resource.extendedProps.originalId + '?categoryId=' + selectedCategory)
              }
            }}
          />
        </div>
      </div>
      <Sidebar position="right" visible={date && resource && resource.includes('U')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_PriceUnitFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={date && resource && resource.includes('C')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_PriceCategoryFormComponent/>
      </Sidebar>
    </>
  )
}
export default withTranslation('common')(_FM_PricePage);
